import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ProjectService, CommonService, FileService } from '../../_services/';
import * as fileSaver from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-project-map-files-dialog',
  templateUrl: './project-map-files-dialog.component.html',
  styleUrls: ['./project-map-files-dialog.component.scss']
})
export class ProjectMapFilesDialogComponent implements OnInit {
  files:{}[];
  fieldName:String;
  private subscription: Subscription;
  private subscription2: Subscription;
  constructor(
    public dialogRef: MatDialogRef<ProjectMapFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _project : ProjectService,
    private _common : CommonService,
    private _file : FileService
  ) { }

  ngOnInit() {
    this.getFileFields();
  }
  

  hideDialog(){
    this.dialogRef.close();
  }

  getFileFields(){
    this._common.showLoader(true);
    this.subscription = this._project.getFileFields(this.data.field_id, this.data.project_id).subscribe(res =>{
      this._common.showLoader(false);
      this.files = res.map(item=>item.payload.doc.data());
      this.subscription2 = this._project.getFileFieldName(this.data.field_id).subscribe(res2 =>{
      this.fieldName = res2[0].payload.doc.data()['name'];
      },error=>{
        console.log('Something went wrong!');
      })
    },error=>{
      console.log('Something went wrong!');
    });
  }

  download(url) {
    this._file.downloadFile(url).subscribe(response => {
			let blob:any = new Blob([response.blob()], { type: 'text/json; charset=utf-8' });
      fileSaver.saveAs(blob, `download.${url.split('?')[0].split('.').reverse()[0]}`);
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully'); 
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
  }

}
